import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MainMenu from "../shared/MainMenu/MainMenu";
import UserCard from "../shared/UserCard/UserCard";
import AdminWidget from "../Widget/AdminWidget/AdminWidget";
import LkWidget from "../Widget/LkWidget/LkWidget";
import MessagesWidget
    from "../Widget/MessagesWidget/MessagesWidget";
import NotificationsWidget
    from "../Widget/NotificationsWidget/NotificationsWidget";
import SupplyWidget
    from "../Widget/SupplyWidget/SupplyWidget";
// import VerificationsWidget
//     from "../Widget/VerificationsWidget/VerificationsWidget";
import './FactoroilPage.scss';
import DebtorWidget from '../Widget/DebtorWidget/DebtorWidget';

class FactoroilPage extends Component {
    static propTypes = {
        userInfo: PropTypes.object,
        classPrefix: PropTypes.string,
        role: PropTypes.string,
        basketCnt: PropTypes.number,
    }
    constructor(props) {
        super(props)
        this.state = {
            activeItem: props.userInfo.role === 'admin' ?
                (<AdminWidget {...this.props} userInfo={this.props.userInfo}
                              countRegistration={this.setCounts}/>) :
                (<SupplyWidget {...this.props} basketCnt={this.setBasket}/>),
            activeItemIdx: this.props.userInfo.role === 'admin' ?
                'notifications' : 'supply',
            userInfo: this.props.userInfo,
            basketCnt: this.props.basketCnt,
            notices: {},
            listVendor: [
            {
              "id": 1,
              "name": "Андрей",
              "sureName": "Королев",
              "middleName": "Владимирович",
              "position": "Генеральный директор",
              "phone": "8 (499) 941 09 04",
              "email": "info@akros-llc.com",
              "site": "akros-llc.com",
              "address": "117485, Москва, ул. Академика Волгина, 2Б, стр. 2",
              "avatar": "korolev",
              "logo": "akros",
              "nameCompany": "Акрос ООО",
              "companyGroup": "",
              "amountAll": 432650000,
              "supplyAll": 10,
              "report": 5,
              "career": "Добыча природного газа и газового конденсата",
              "inn": "8904034784",
              "kpp": "890401001",
              "ogrn": "1028900628932",
              "okpo": "5751745",
              "capital": "12,7 млн. руб",
              "age": "18",
              "companyPrice": "70,9 млн. руб",
              "billing": "211,5 млн. руб",
              "profit": "6,8 млн. руб"
            },
            {
              "id": 2,
              "name": "Алексей",
              "sureName": "Володин",
              "middleName": "Михайлович",
              "position": "Генеральный директор",
              "phone": "8 (4912) 308 193",
              "email": "pptkpo@tkpo.ryazan.ru",
              "site": "tkpo.ryazan.ru",
              "address": "390042, Россия, Рязань, Промышленная, 5",
              "avatar": "volodin",
              "logo": "tpm",
              "nameCompany": "ТяжПрессМаш ОАО",
              "companyGroup": "",
              "amountAll": 532650000,
              "supplyAll": 10,
              "report": 5,
              "career": "Добыча природного газа и газового конденсата",
              "inn": "8904034784",
              "kpp": "890401001",
              "ogrn": "1028900628932",
              "okpo": "5751745",
              "capital": "9,7 млн. руб",
              "age": "16",
              "companyPrice": "53,9 млн. руб",
              "billing": "128,5 млн. руб",
              "profit": "4,8 млн. руб"
            },
            {
              "id": 3,
              "name": "Владимир",
              "sureName": "Шестериков",
              "middleName": "Савельевич",
              "position": "Генеральный директор",
              "phone": "8 (495) 2 257 595",
              "email": "cck@sibserv.com",
              "site": "sibserv.com",
              "address": "125284, г. Москва, Ленинградский проспект, д. 31А, стр.1, 9 этаж",
              "avatar": "shestakov",
              "logo": "sibserv",
              "nameCompany": "Сибирская Сервисная Компания АО",
              "companyGroup": "",
              "amountAll": 362650000,
              "supplyAll": 10,
              "report": 4,
              "career": "Добыча природного газа и газового конденсата",
              "inn": "8904034784",
              "kpp": "890401001",
              "ogrn": "1028900628932",
              "okpo": "5751745",
              "capital": "11,2 млн. руб",
              "age": "14",
              "companyPrice": "50,9 млн. руб",
              "billing": "131,2 млн. руб",
              "profit": "3,8 млн. руб"
            }
          ],
            listDebtor: [
              {
                "id": 1,
                "name": "Игорь",
                "sureName": "Онешко",
                "middleName": "Владимирович",
                "position": "Генеральный директор",
                "phone": "8 (3452) 38 22 97",
                "email": "rn-uvatng@uvng.rosneft.ru",
                "site": "ung.rosneft.ru",
                "address": "625000, г. Тюмень, ул. Ленина,67",
                "avatar": "oneshko",
                "logo": "rn",
                "nameCompany": "РН-Уватнефтегаз ООО",
                "companyGroup": {"icon": "rn", "txt": "НК Роснефть"},
                "amountAll": 432650000,
                "supplyAll": 10,
                "report": 5,
                "career": "Добыча природного газа и газового конденсата",
                "inn": "8904034784",
                "kpp": "890401001",
                "ogrn": "1028900628932",
                "okpo": "5751745",
                "capital": "12,7 млрд. руб",
                "age": "18 лет",
                "companyPrice": "70,9 млрд. руб",
                "billing": "211,5 млрд. руб",
                "profit": "6,8 млрд. руб"
              },
              {
                "id": 2,
                "name": "Александр",
                "sureName": "Корякин",
                "middleName": "Юрьевич",
                "position": "Генеральный директор",
                "phone": "8 (3494) 948 409",
                "email": "gdu@gd-urengoy.gazprom.ru",
                "site": "urengoy-dobycha.gazprom.ru",
                "address": "г. Новый Уренгой, ул. Железнодорожная д.8",
                "avatar": "koryakin",
                "logo": "gaz",
                "nameCompany": "Газпром добыча Уренгой ООО",
                "companyGroup": {"icon": "gaz", "txt": "Газпром"},
                "amountAll": 532650000,
                "supplyAll": 10,
                "report": 5,
                "career": "Добыча природного газа и газового конденсата",
                "inn": "8904034784",
                "kpp": "890401001",
                "ogrn": "1028900628932",
                "okpo": "5751745",
                "capital": "11,3 млрд. руб",
                "age": "15 лет",
                "companyPrice": "70,9 млрд. руб",
                "billing": "151,5 млрд. руб",
                "profit": "7,2 млрд. руб"
              },
              {
                "id": 3,
                "name": "Сергей",
                "sureName": "Кочкуров",
                "middleName": "Алексеевич",
                "position": "Генеральный директор",
                "phone": "8 (34667) 2 98 00",
                "email": "ws@lukoil.com",
                "site": "zs.lukoil.ru",
                "address": "628486, ХМАО — Югра, г. Когалым, ул. Прибалтийская, 20",
                "avatar": "kochkurov",
                "logo": "luk",
                "nameCompany": "ЛУКОЙЛ-Западная Сибирь ООО",
                "companyGroup": {"icon": "luk", "txt": "Лукойл"},
                "amountAll": 362650000,
                "supplyAll": 10,
                "report": 4,
                "career": "Добыча природного газа и газового конденсата",
                "inn": "8904034784",
                "kpp": "890401001",
                "ogrn": "1028900628932",
                "okpo": "5751745",
                "capital": "8,3 млрд. руб",
                "age": "12 лет",
                "companyPrice": "70,9 млрд. руб",
                "billing": "131,5 млрд. руб",
                "profit": "5,1 млрд. руб"
              }
            ],
          DebtWidget: null,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            nextProps,
            activeItem: nextProps.userInfo.role === 'admin' ?
                (<AdminWidget
                    countRegistration={this.setCounts}
                    {...this.props}
                    userInfo={this.props.userInfo}
                              />) :
                (<SupplyWidget {...this.props} basketCnt={this.setBasket}/>),
            activeItemIdx: this.props.userInfo.role === 'admin' ?
                'notifications' : 'supply',
        });
    }
    setBasket = count => {
        this.setState({
            basketCnt: count,
        })
    }
    setCounts = count => {
        this.setState({
            notices: {
                messages: Math.round(Math.random()*99),
                notifications: Math.round(Math.random()*99),
                verification: '',
                registration: count,
            },
        })
    }
    handlerDebtWidget = (val) => {
      this.setState({
        DebtWidget: val
      })
    }

    handleMenuItem = menuItem => {
        const {userInfo, DebtWidget} = this.state;
        const content = {
            lk:
                (<LkWidget
                    {...this.props}
                    userInfo={userInfo}/>),
            messages: (<MessagesWidget {...this.props}
                                       userInfo={userInfo}/>),
            // registration: (<AdminWidget
            //     {...this.props}
            //     userInfo={userInfo}
            //     countRegistration={this.setCounts}/>), //TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            notifications: (<NotificationsWidget
                    {...this.props}
                    userInfo={userInfo} />),
            verification: '', //(<VerificationsWidget {...this.props}/>), // пока это кнопка выхода
            supply: (<SupplyWidget
                {...this.props}
                userInfo={userInfo} basketCnt={this.setBasket}/>),
            basket: (<SupplyWidget
                {...this.props}
                userInfo={userInfo} basketCnt={this.setBasket} isBasket={true}/>),
            vendor: (<DebtorWidget {...this.props} listDebtors={this.state.listVendor} roleAcc={'vendor'} debtWidgetOn={DebtWidget}/>),
            debtor: (<DebtorWidget {...this.props} listDebtors={this.state.listDebtor} roleAcc={'debtor'} debtWidgetOn={DebtWidget}/>),
        }

        this.setState({
            activeItem: content[menuItem],
            activeItemIdx: menuItem,
        }) ;
    }

    render() {
        const {classPrefix} = this.props;
        const {activeItem, activeItemIdx, userInfo, notices, basketCnt} = this.state;

        return (<div className={`adminPage${classPrefix}`}>
            <MainMenu handelMainMenuItem={this.handleMenuItem}
                      activeMenu={activeItemIdx}
                      userInfo={userInfo}
                      basketCnt={basketCnt}
                      switchOntoTable={this.handlerDebtWidget}
                      {...this.props}
                      />
            {!classPrefix ? <UserCard handleUserMenuItem={this.handleMenuItem}
                                      userInfo={userInfo}
                                      {...this.props}
                                      activeMenu={activeItemIdx}
                                      notices={notices}
                                      /> : null}
            {activeItem}
        </div>)
    }
}

export default FactoroilPage;



// WEBPACK FOOTER //
// ./src/FactoroilPage/FactoroilPage.js